import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function CTA() {
  return <section id="cta" className="py-12 md:py-24 relative overflow-hidden" style={{
    background: 'linear-gradient(135deg, #5B2C6F 0%, #7D3C98 30%, #27AE60 60%, #F5E6D0 100%)'
  }} data-id="element-56">
      {/* Julienne texture */}
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none" data-id="element-57">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-58">
          <defs data-id="element-59">
            <pattern id="julienne-cta" x="0" y="0" width="50" height="50" patternUnits="userSpaceOnUse" patternTransform="rotate(30)" data-id="element-60">
              <path d="M0 25 Q12 20, 25 25 T50 25" fill="none" stroke="#fff" strokeWidth="1.5" data-id="element-61" />
              <path d="M0 12 Q12 7, 25 12 T50 12" fill="none" stroke="#fff" strokeWidth="1" data-id="element-62" />
              <path d="M0 38 Q12 33, 25 38 T50 38" fill="none" stroke="#fff" strokeWidth="1" data-id="element-63" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#julienne-cta)" data-id="element-64" />
        </svg>
      </div>

      {/* Decorative blobs */}
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-cabbage-dark rounded-full blur-3xl opacity-40" data-id="element-65"></div>
      <div className="absolute top-0 left-0 w-64 h-64 bg-leaf-dark rounded-full blur-3xl opacity-10" data-id="element-66"></div>

      <div className="container mx-auto px-5 md:px-6 max-w-4xl text-center relative z-10" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white/95 backdrop-blur-sm p-8 md:p-16 rounded-3xl shadow-2xl border border-white/50 relative overflow-hidden" data-id="element-68">
          <div className="relative z-10" data-id="element-69">
            <div className="inline-block bg-cabbage/10 text-cabbage-dark font-serif text-sm px-4 py-2 rounded-full mb-6" data-id="element-70">
              🍽️ 66 recetas esperan por ti
            </div>
            <h2 className="text-3xl md:text-5xl font-serif text-cabbage-dark mb-4 md:mb-6" data-id="element-71">
              Transforma tu cocina hoy
            </h2>
            <p className="text-base md:text-lg text-gray-600 mb-6 md:mb-10 max-w-2xl mx-auto" data-id="element-72">
              El resultado es una guía práctica, visual y versátil que convierte
              un ingrediente sencillo en una herramienta poderosa para crear
              comidas ligeras, saludables, económicas y visualmente
              espectaculares.
            </p>

            <div className="flex items-center justify-center gap-4 mb-6" data-id="element-73">
              <span className="text-lg md:text-xl text-gray-400 line-through font-sans" data-id="element-74">
                8,99 €
              </span>
              <span className="text-4xl md:text-5xl font-serif text-leaf-dark font-bold" data-id="element-75">
                4,99 €
              </span>
            </div>
            <p className="text-sm text-cabbage font-semibold mb-6" data-id="element-76">
              ¡Ahorra un 44%!
            </p>

            <motion.a href="https://shop.beacons.ai/saludybelleza3.0/cc176147-aa73-4576-a02b-b311da241b58" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="bg-leaf hover:bg-leaf-dark text-white px-6 py-4 md:px-10 md:py-5 rounded-full font-sans font-medium text-base md:text-lg transition-colors shadow-lg flex items-center gap-2 md:gap-3 mx-auto no-underline" data-id="element-77">
              <BookOpen size={20} data-id="element-78" />
              Obtener la Guía de 66 Recetas
            </motion.a>
            <p className="mt-3 md:mt-4 text-xs md:text-sm text-gray-400 font-sans" data-id="element-79">
              Descarga inmediata • Formato Digital
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}